import { createTopAnomalousKey } from 'constants/queryCacheKeys';
import { TGetTopAnomalousParams, getTopAnomalous } from 'domain/objectives';
import { useQuery } from 'react-query';

export const useTopAnomalousQuery = (params: TGetTopAnomalousParams) => {
  return useQuery(createTopAnomalousKey(params), () => getTopAnomalous(params), {
    keepPreviousData: true,
  });
};
